import BlogGridsContainer from "../../../../Components/Miscellaneous/Blog/BlogGrids/BlogGridsContainer";

const BlogGrids = () => {
  return <BlogGridsContainer />;
};

export default BlogGrids;
